import React from "react";
import { notify } from "@/shared/utils/notify";
import { promotionRulesService } from "../../../shared/services";

export interface IPromotionRule {
  id: number;
  name: string;
  description?: string;
  promo_type: "2x1" | "3x2" | "custom";
  status: "active" | "inactive";
  monday: "true" | "false";
  tuesday: "true" | "false";
  wednesday: "true" | "false";
  thursday: "true" | "false";
  friday: "true" | "false";
  saturday: "true" | "false";
  sunday: "true" | "false";
  discount_type: "cheapest_free" | "percentage" | "fixed_price";
  discount_value?: number;
  banner_path?: string;
  start_date?: string;
  end_date?: string;
  rule_categories?: IPromotionRuleCategory[];
  excluded_products?: IPromotionExcludedProduct[];
  excluded_product_ids?: number[];
  free_products?: IPromotionFreeProduct[];
  free_product_ids?: number[];
  createdAt?: string;
  updatedAt?: string;
}

export interface IPromotionExcludedProduct {
  id: number;
  promotion_rule_id: number;
  product_id: number;
  product?: {
    id: number;
    name: string;
  };
}

export interface IPromotionFreeProduct {
  id: number;
  promotion_rule_id: number;
  product_id: number;
  product?: {
    id: number;
    name: string;
  };
}

export interface IPromotionRuleCategory {
  id: number;
  promotion_rule_id: number;
  category_id: number;
  role: "primary" | "secondary";
  required_quantity: number;
  is_required: "true" | "false";
  position: number;
  category?: {
    id: number;
    name: string;
  };
}

export const usePromotions = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [promotions, setPromotions] = React.useState<IPromotionRule[]>([]);
  const [refreshKey, setRefreshKey] = React.useState<number>(0);

  const getPromotions = async () => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await promotionRulesService.find({
        query: {
          $sort: { createdAt: -1 },
          $limit: 100,
        },
      });
      setPromotions(res.data || []);
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const refresh = () => {
    setRefreshKey((prev) => prev + 1);
  };

  React.useEffect(() => {
    getPromotions();
  }, [refreshKey]);

  return {
    loading,
    promotions,
    refresh,
    getPromotions,
  };
};
